import  { useDispatch } from "react-redux";
// import axios from '../api/http-common';
import  {  logout, setCredentials } from "../context/auth/authSlice";
import { useLazyRefreshTokenQuery } from "context/auth/authApiSlice";

const useRefreshToken = () => {

    const dispatch = useDispatch();
    const [getRefreshToken] = useLazyRefreshTokenQuery(undefined, {
          // pollingInterval: 60000,
          refetchOnMountOrArgChange: true,
      });

    const refresh = async () => {
        try {
            const response = await getRefreshToken().unwrap();
            const result   = response.data;
            if(result){
                dispatch(setCredentials({...result}));
            }else{
                dispatch(logout());
            }
            return result.accessToken;
        }catch(e){
            // console.log(e)
        }  
    }
    return refresh;
};


export default useRefreshToken;